export default "__VITE_ASSET__ec967776__"